import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              !_vm.tplToWork
                ? _c("p", [_vm._v("Template not found!")])
                : _vm._e(),
              _c("loading", {
                attrs: {
                  active: _vm.isLoading,
                  "can-cancel": true,
                  "on-cancel": _vm.onCancel,
                  "is-full-page": true,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.isLoading = $event
                  },
                },
              }),
              _vm.tplToWork && _vm.defaultFields
                ? _c(
                    VForm,
                    { ref: "form" },
                    [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm._f("joinTableReference")(_vm.tableReference)
                          )
                        ),
                      ]),
                      _c(
                        VTabs,
                        [
                          _c(VTab, [_vm._v(_vm._s(_vm.texts.rules))]),
                          _c(
                            VTabItem,
                            [
                              _c("profiling-rules", {
                                attrs: {
                                  record: _vm.profilingRule,
                                  readonly: _vm.existsCurrentProfiling,
                                  tableReference: _vm.tableReference,
                                  domainTable: _vm.domain_table,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(VTab, [_vm._v(_vm._s(_vm.texts.columns))]),
                          _c(
                            VTabItem,
                            [
                              _c("profiling-columns", {
                                attrs: {
                                  columnFields: _vm.columnFields,
                                  readonly: _vm.existsCurrentProfiling,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "12", lg: "12" } },
                            [
                              _c(
                                "b-alert",
                                {
                                  attrs: {
                                    show: _vm.dismissCountDown,
                                    dismissible: "",
                                    variant: "danger",
                                  },
                                  on: {
                                    dismissed: function ($event) {
                                      _vm.dismissCountDown = 0
                                    },
                                    "dismiss-count-down": _vm.countDownChanged,
                                  },
                                },
                                [
                                  _c("p", [_vm._v(_vm._s(_vm.dangerMessage))]),
                                  _c("b-progress", {
                                    attrs: {
                                      variant: "danger",
                                      max: _vm.dismissSecs,
                                      value: _vm.dismissCountDown,
                                      height: "4px",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("b", [
                    _vm._v(
                      "Error at load data! The resource may not have metadata."
                    ),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: _vm.MODAL_CONFIRM_EDIT,
          attrs: {
            id: _vm.MODAL_CONFIRM_EDIT,
            title: "CONFIRM EDIT PROFILING RULE",
            size: "sm",
            "hide-footer": "",
          },
        },
        [
          _c("modal-confirm", {
            attrs: { message: "Do you want to edit this profiling rule?" },
            on: {
              submitItem: _vm.operationProfilingRule,
              closeConfirmModal: function ($event) {
                return _vm.closeModal(_vm.MODAL_CONFIRM_EDIT)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }